<div class="ui basic segment" [class.loading]="isLoading">
    <form #form="ngForm" (ngSubmit)="onSubmit()">
        <app-header title="time-tracking.generalSettingsPage.title" [back]="true"></app-header>
        <ui-card>
            <h3>{{ 'time-tracking.generalSettingsPage.weeklyDeadlineTitle' | translate }}</h3>
            <p>{{ 'time-tracking.generalSettingsPage.weeklyDeadline' | translate }}</p>
            <div class="margin-bottom-1">
                <mat-radio-group
                    [value]="this.settings.remindersWeeklyDeadline"
                    (change)="this.settings.remindersWeeklyDeadline = $event.value"
                    name="reminderCheckOptions"
                    required
                    class="vertical"
                >
                    <mat-radio-button class="margin-bottom-1" [value]="true" required>{{
                        'yes' | translate
                    }}</mat-radio-button>

                    <mat-radio-button [value]="false" required>{{ 'no' | translate }}</mat-radio-button>
                </mat-radio-group>
            </div>
            <ng-container *ngIf="this.settings.remindersWeeklyDeadline; else noReminders">
                <div class="flex align-items-center">
                    <mat-form-field class="columns-1 small-columns-12">
                        <mat-select
                            name="timeTrackingReminderDay"
                            [(ngModel)]="settings.remindersWeeklyDeadlineDayOfWeek"
                            (selectionChange)="onDaySelectionChange($event.value)"
                            required
                        >
                            <mat-option [value]="day.value" *ngFor="let day of days">
                                {{ day.translationString | translate }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                    <span class="margin-left-2 margin-right-2">{{
                        'time-tracking.generalSettingsPage.at' | translate
                    }}</span>
                    <mat-form-field class="columns-1 small-columns-12">
                        <mat-select
                            name="timeTrackingReminderTime"
                            [(ngModel)]="settings.remindersWeeklyDeadlineTimeOfDay"
                            (selectionChange)="selectedDisplayTime = $event.source.triggerValue"
                            required
                        >
                            <mat-option [value]="timeOption.value" *ngFor="let timeOption of timeOptions">
                                {{ timeOption.display }}&nbsp;<span
                                    translate="time-tracking.generalSettingsPage.timeZones.{{ timeZone }}"
                                ></span>
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>

                <h3>{{ 'time-tracking.generalSettingsPage.weeklyReminderTitle' | translate }}</h3>
                <p>{{ 'time-tracking.generalSettingsPage.weeklyReminderText' | translate }}</p>

                <!-- Approver reminders -->
                <ui-card class="w-100 lg-w-75 xxl-w-50" variant="outline">
                    <p class="font-medium">{{ 'time-tracking.generalSettingsPage.remindHelpText' | translate }}</p>
                    <div
                        *ngFor="let approverReminder of approverReminders; let i = index"
                        class="flex justify-space-between margin-bottom-2 align-items-center"
                    >
                        <mat-form-field class="no-labels no-helpers custom-width">
                            <mat-select
                                name="remindApprovers-{{ i }}"
                                [ngModel]="approverReminder.deadline"
                                (selectionChange)="updateApproverReminderDeadline(approverReminder, $event.value)"
                                required
                            >
                                <mat-option
                                    [value]="numberOfDay"
                                    *ngFor="let numberOfDay of numberOfDays"
                                    [disabled]="isDaySelected(numberOfDay, approverReminders, i)"
                                >
                                    {{ numberOfDay }}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                        <p
                            [innerHTML]="
                                'time-tracking.generalSettingsPage.dateAndTimeText'
                                    | translate
                                        : {
                                              dayOfWeek:
                                                  ('time-tracking.generalSettingsPage.' + approverReminder.dayOfWeek
                                                  | translate),
                                              time: selectedDisplayTime,
                                          }
                                    | sanitizeHtml
                            "
                            class="margin-left-2 margin-bottom-0"
                            [ngClass]="{
                                'text-basis-80': approverReminders.length > 1,
                                'text-basis-90': approverReminders.length === 1,
                            }"
                        ></p>
                        <mat-icon
                            class="margin-left-5 point"
                            *ngIf="approverReminders.length > 1"
                            (click)="removeApproverReminder(i)"
                            svgIcon="trash"
                        ></mat-icon>
                    </div>
                    <ui-button
                        name="addApproverReminder"
                        (click)="addApprovalReminder()"
                        type="outline"
                        [disabled]="approverReminders.length >= 3"
                        ><mat-icon svgIcon="plus"></mat-icon
                        >{{ 'time-tracking.generalSettingsPage.addReminderButton' | translate }}</ui-button
                    >
                </ui-card>

                <!-- Employee reminders -->
                <ui-card class="w-100 lg-w-75 xxl-w-50" variant="outline">
                    <p class="font-medium">
                        {{ 'time-tracking.generalSettingsPage.remindEmployeeDeadline' | translate }}
                    </p>
                    <div
                        *ngFor="let employeeReminder of employeeReminders; let i = index"
                        class="flex justify-space-between margin-bottom-2 align-items-center"
                    >
                        <mat-form-field class="no-labels no-helpers custom-width">
                            <mat-select
                                name="remindEmployees-{{ i }}"
                                [ngModel]="employeeReminder.deadline"
                                (selectionChange)="updateEmployeeReminderDeadline(employeeReminder, $event.value)"
                                required
                            >
                                <mat-option
                                    [disabled]="isDaySelected(numberOfDay, employeeReminders, i)"
                                    [value]="numberOfDay"
                                    *ngFor="let numberOfDay of numberOfDays"
                                >
                                    {{ numberOfDay }}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>

                        <p
                            [innerHTML]="
                                'time-tracking.generalSettingsPage.dateAndTimeText'
                                    | translate
                                        : {
                                              dayOfWeek:
                                                  ('time-tracking.generalSettingsPage.' + employeeReminder.dayOfWeek
                                                  | translate),
                                              time: selectedDisplayTime,
                                          }
                            "
                            class="margin-left-2 margin-bottom-0"
                            [ngClass]="{
                                'text-basis-90': employeeReminders.length > 1,
                                'text-basis-95': employeeReminders.length === 1,
                            }"
                        ></p>
                        <mat-icon
                            class="point"
                            *ngIf="employeeReminders.length > 1"
                            (click)="removeEmployeeReminder(i)"
                            svgIcon="trash"
                        ></mat-icon>
                    </div>
                    <ui-button
                        name="addEmployeeReminder"
                        (click)="addEmployeeReminder()"
                        type="outline"
                        [disabled]="employeeReminders.length >= 3"
                        ><mat-icon svgIcon="plus"></mat-icon
                        >{{ 'time-tracking.generalSettingsPage.addReminderButton' | translate }}</ui-button
                    >
                </ui-card>
            </ng-container>

            <ng-template #noReminders>
                <h3>{{ 'time-tracking.generalSettingsPage.weeklyReminderTitle' | translate }}</h3>
                <p class="subtitle">{{ 'time-tracking.generalSettingsPage.noReminders' | translate }}</p>
                <ui-banner class="quarter-width" variant="info">
                    <p>{{ 'time-tracking.generalSettingsPage.remindersWillBeAvailable' | translate }}</p>
                </ui-banner>
            </ng-template>

            <!-- track future hours -->
            <h3>{{ 'time-tracking.generalSettingsPage.preferences' | translate }}</h3>

            @if (hasTimeClockFlag) {
                <div class="margin-bottom-1 font-medium">
                    {{ 'time-tracking.generalSettingsPage.selectPreferred' | translate }}
                </div>

                <mat-radio-group
                    [value]="settings.timeTrackingMethod ?? 'hours'"
                    (change)="
                        settings.timeTrackingMethod = $event.value;
                        timeTrackingSettingsService.invalidate();
                        onStartAndEndTimeToggle($event.value)
                    "
                    name="timeTrackingMethodOptions"
                    required
                    class="vertical margin-bottom-2"
                >
                    <mat-radio-button class="margin-bottom-1" [value]="'hours'" required>
                        <div>{{ 'time-tracking.generalSettingsPage.trackByHours' | translate }}</div>
                        <div class="subtitle">
                            {{ 'time-tracking.generalSettingsPage.trackByHoursHint' | translate }}
                        </div>
                    </mat-radio-button>
                    <mat-radio-button [value]="'start_end_time'" required>
                        <div>{{ 'time-tracking.generalSettingsPage.trackByStartEnd' | translate }}</div>
                        <div class="subtitle">
                            {{ 'time-tracking.generalSettingsPage.trackByStartEndHint' | translate }}
                        </div>
                    </mat-radio-button>
                </mat-radio-group>
            }

            @if (hasTimerClockFlag && settings.timeTrackingMethod === 'start_end_time') {
                <div class="margin-bottom-1 font-medium">
                    {{ 'time-tracking.generalSettingsPage.timeClockRounding' | translate }}
                </div>

                <mat-radio-group
                    [value]="settings.allowTimeClockRounding ?? false"
                    (change)="
                        settings.allowTimeClockRounding = $event.value;
                        timeTrackingSettingsService.invalidate();
                        setDefaultRoundingValues()
                    "
                    name="timeClockRoundingOptions"
                    required
                    class="vertical margin-bottom-2"
                >
                    <mat-radio-button class="margin-bottom-1" [value]="true" required>
                        <div>{{ 'yes' | translate }}</div>
                    </mat-radio-button>
                    <mat-radio-button [value]="false" required>
                        <div>{{ 'no' | translate }}</div>
                    </mat-radio-button>
                </mat-radio-group>

                @if (settings.allowTimeClockRounding) {
                    <div class="margin-bottom-1 font-medium">
                        {{ 'time-tracking.generalSettingsPage.timeClockRoundingTitle' | translate }}
                    </div>
                    <div class="flex margin-bottom-1 rounding-selects">
                        <mat-form-field class="no-labels no-helpers">
                            <mat-select
                                [(ngModel)]="settings.timeClockRoundingMode"
                                (selectionChange)="timeTrackingSettingsService.invalidate()"
                                name="timeClockRoundingMode"
                                required
                            >
                                <mat-option [value]="'nearest'">{{
                                    'time-tracking.generalSettingsPage.roundToNearest' | translate
                                }}</mat-option>
                                <mat-option [value]="'up'">{{
                                    'time-tracking.generalSettingsPage.roundUpToNearest' | translate
                                }}</mat-option>
                            </mat-select>
                        </mat-form-field>

                        <mat-form-field class="no-labels no-helpers">
                            <mat-select
                                [(ngModel)]="settings.timeClockRoundingMinutes"
                                (selectionChange)="timeTrackingSettingsService.invalidate()"
                                name="timeClockRoundingMinutes"
                                required
                            >
                                <mat-option [value]="5"
                                    >5 {{ 'time-tracking.generalSettingsPage.minutes' | translate }}</mat-option
                                >
                                <mat-option [value]="10"
                                    >10 {{ 'time-tracking.generalSettingsPage.minutes' | translate }}</mat-option
                                >
                                <mat-option [value]="15"
                                    >15 {{ 'time-tracking.generalSettingsPage.minutes' | translate }}</mat-option
                                >
                            </mat-select>
                        </mat-form-field>
                    </div>

                    <div class="subtitle margin-bottom-2">
                        {{ 'time-tracking.generalSettingsPage.roundingHint' | translate }}
                    </div>
                }
            }

            <p class="font-medium">{{ 'time-tracking.generalSettingsPage.allowFutureTimeTracking' | translate }}</p>
            <div class="margin-bottom-2">
                <mat-radio-group
                    [value]="settings.allowFutureEntries ?? false"
                    (change)="settings.allowFutureEntries = $event.value; timeTrackingSettingsService.invalidate()"
                    name="allowFutureEntriesCheckOptions"
                    required
                    class="vertical"
                >
                    <mat-radio-button class="margin-bottom-1" [value]="true" required>{{
                        'yes' | translate
                    }}</mat-radio-button>
                    <mat-radio-button [value]="false" required>{{ 'no' | translate }}</mat-radio-button>
                </mat-radio-group>
            </div>
            <ng-container *ngIf="settings.allowFutureEntries">
                <p class="future-days-label font-medium">
                    {{ 'time-tracking.generalSettingsPage.howManyDays' | translate }}
                </p>
                <mat-form-field>
                    <input
                        name="futureEntriesAllowedDays"
                        type="number"
                        [min]="1"
                        [max]="90"
                        pattern="[0-9]+"
                        placeholder="30"
                        required
                        matInput
                        [(ngModel)]="settings.futureEntriesAllowedDays"
                        #futureEntriesAllowedDays="ngModel"
                    />
                    <span matSuffix>{{ 'dateTime.days' | translate | lowercase }}</span>

                    <mat-error *ngIf="futureEntriesAllowedDays.invalid">
                        {{ futureEntriesAllowedDays.errors | formErrors }}
                    </mat-error>
                </mat-form-field>
            </ng-container>
        </ui-card>

        <div class="flex buttons justify-end">
            <ui-button (click)="onCancel()" type="ghost">{{ 'cancel' | translate }}</ui-button>
            <ui-button [submit]="true" type="primary">{{ 'save' | translate }}</ui-button>
        </div>
    </form>
</div>
